module.exports = __webpack_public_path__ + "static/media/youth.194e197f.jpg";